module.exports = __webpack_public_path__ + "img/teacher_vip.67349820.jpg";